export const environment = {
  production: true,
  rapi: 'https://api.ltsnhelp.com',
  multisite: {
    name: '70-percent-powerball',
    view: '.discount-product',
    apiresources: 'https://d3tmfelegj51yl.cloudfront.net/landings/discount-product/language/powerball/',
    defaultLang: { lenid: 'en', lennombre: 'English' },
    langs: [
      { lenid: 'en', lennombre: 'English' },
      { lenid: 'es', lennombre: 'Español' },
      { lenid: 'pt', lennombre: 'Portugues' }
    ]
  },
  sentry: {
    dsn: 'https://8122d2bf17a14a61b01885af3a9f4e90@sentry.io/5029794',
    reportDialog: false,
    enable: false,
    logs: false
  },
  environment: '70-percent-powerball.prod',
  version: '1.0',
  lottery: {
    lot_id: 3,
    pcode: {
      wt: 'PCPOWER70OFFWT',
      ltk: 'PCPOWER70OFFLT'
    },
    type: 'nxnoffer',
    synd_prc_code: {
      wt: 0,
      ltk: 0
    },
    offer: {
      base: 1,
      multiplier: 1,
      picks: {
        count: 5,
        from: 1,
        to: 69
      },
      extra_picks: {
        count: 1,
        from: 1,
        to: 26
      }
    }
  },
  pcode: {
    wt: 'PCPOWER70OFFWT',
    ltk: 'PCPOWER70OFFLT'
  },
  type: 'discount-product',
  product_type: 1,
  product_id: 3,
  pick_type: 3,
  source: 'ng-70-percent-powerball',
  domainRestriction: null,
  upsellPage: null,
  promoSyndicate: false,
  templateIdPromoWT: 150,
  templateIdPromoLTK: 151,
  AES_CODE: '0PC0s9#MrgPHaJHi'
};
